<template>
  <div>
    <notification-message
      message="Parece que aún no agregas borradores" v-if="posts.length == 0"
    />
    <div class="main-content-container container-fluid px-4">
      <div>
        <div class="page-header row no-gutters py-4">
          <div class="col-12 col-sm-4 text-center text-sm-left mb-0">
            <span class="text-uppercase page-subtitle">Borradores</span>
            <h3 class="page-title">Visión general</h3>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-3 col-md-6 col-sm-12 mb-4" v-for="(post, index) in posts" :key="index">
            <div class="card card-small card-post card-post--1">
              <div class="card-post__image" :style="'background-image: url('+ post.image +');'">
                <a href="#" class="card-post__category badge badge-pill badge-dark">
                  {{ post.category }}
                </a>
                <div class="card-post__author d-flex">
                  <a href="#" :title="post.author" class="card-post__author-avatar card-post__author-avatar--small" :style="'background-image: url('+post.user_photo+');'">Written by Anna Kunis</a>
                </div>
              </div>
              <div class="card-body">
                <h5 class="card-title">
                  <a class="text-fiord-blue" href="#">
                    {{ post.name }} 
                  </a>
                </h5>
                <p class="card-text d-inline-block mb-3">
                  {{ post.excerpt }}
                </p>
                <span class="text-muted d-block">
                  <convert-date :date="post.date"/>
                </span>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import NotificationMessage from '@/components/general/NotificationMessage';
  export default {
    components: { NotificationMessage },
    data() {
      return {
        posts: []
      }
    },

    mounted() {
      this.getProjects();
    },

    methods: {
      async getProjects() {
        let url = process.env.VUE_APP_ROOT_API.concat('/post/drafts');
        let response = await fetch(url);
        this.posts = await response.json(); 
      }
    }
  } 
</script>